import { render, staticRenderFns } from "./CrmRoute.vue?vue&type=template&id=06b86756"
import script from "./CrmRoute.vue?vue&type=script&lang=ts"
export * from "./CrmRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b86756')) {
      api.createRecord('06b86756', component.options)
    } else {
      api.reload('06b86756', component.options)
    }
    module.hot.accept("./CrmRoute.vue?vue&type=template&id=06b86756", function () {
      api.rerender('06b86756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/CrmRoute.vue"
export default component.exports